import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { mark as markPerformance } from '@office-start/performance-service';
import { logError } from '@office-start/telemetry-service';
export function prefetchNorthStar(isCommercialUser) {
    if (isCommercialUser === void 0) { isCommercialUser = false; }
    return __awaiter(this, void 0, void 0, function () {
        var message, err_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    try {
                        markPerformance('PrefetchNorthStar_Started');
                    }
                    catch (err) {
                        message = "Invoked markPerformance in prefetchNorthStar function, but encountered an error : ".concat(err);
                        logError({
                            eventName: KnownInstrumentationEvents.PrefetchNorthStarMarkPerformanceError,
                            errorType: 'NorthStarConfig_Error',
                            message: message,
                        });
                    }
                    return [4 /*yield*/, runAllConfigPrefetchers(isCommercialUser)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    message = "Invoked prefetchNorthStar function, but encountered an error: ".concat(err_1);
                    logError({
                        eventName: KnownInstrumentationEvents.PrefetchNorthStarError,
                        errorType: 'NorthStarConfig_Error',
                        message: message,
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function runAllConfigPrefetchers(isCommercialUser) {
    return __awaiter(this, void 0, void 0, function () {
        var prefetchAppGalleryConfig, prefetchCapabilities, prefetchEdgeworthConfig, prefetchInstallConfig, prefetchMruConfig, prefetchSharedContext, prefetchShellConfig, prefetchTemplatesConfig, configPrefetchPromises, prefetchCommercialConfigs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prefetchAppGalleryConfig = import('@office-start/app-gallery-config-service').then(function (mod) { return mod.prefetchAppGalleryConfig(); });
                    prefetchCapabilities = import('@office-start/capabilities-service').then(function (mod) { return mod.prefetchCapabilities(); });
                    prefetchEdgeworthConfig = import('@office-start/edgeworth-config-service').then(function (mod) { return mod.prefetchEdgeworthConfig(); });
                    prefetchInstallConfig = import('@office-start/install-config-service').then(function (mod) { return mod.prefetchInstallConfig(); });
                    prefetchMruConfig = import('@office-start/mru-config-service').then(function (mod) { return mod.prefetchMruConfig(); });
                    prefetchSharedContext = import('@office-start/context-service').then(function (mod) { return mod.prefetchSharedContext(); });
                    prefetchShellConfig = import('@office-start/shell-config-service').then(function (mod) { return mod.prefetchShellConfig(); });
                    prefetchTemplatesConfig = import('@office-start/templates-config-service').then(function (mod) { return mod.prefetchTemplatesConfig(); });
                    configPrefetchPromises = [
                        prefetchAppGalleryConfig,
                        prefetchCapabilities,
                        prefetchEdgeworthConfig,
                        prefetchInstallConfig,
                        prefetchMruConfig,
                        prefetchSharedContext,
                        prefetchShellConfig,
                        prefetchTemplatesConfig,
                    ];
                    prefetchCommercialConfigs = Promise.resolve();
                    if (isCommercialUser) {
                        prefetchCommercialConfigs = Promise.all([
                            import('@office-start/people-card-config-service').then(function (mod) {
                                return mod.prefetchPeopleCardConfig();
                            }),
                            import('@office-start/search-config-service').then(function (mod) {
                                return mod.prefetchSearchConfig();
                            }),
                        ]).then(function () { return Promise.resolve(); });
                    }
                    configPrefetchPromises = __spreadArray(__spreadArray([], __read(configPrefetchPromises), false), [
                        prefetchCommercialConfigs,
                    ], false);
                    return [4 /*yield*/, Promise.all(configPrefetchPromises)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=prefetchNorthStar.js.map